import { getToken } from './auth.js'


// 动态获取 baseUrl（优先使用从安卓获取的 host）
function getDynamicBaseUrl() {
  // 优先使用从安卓获取的 dynamicBaseUrl
  const storedBaseUrl = localStorage.getItem('dynamicBaseUrl')
  const dynamicHost = localStorage.getItem('dynamicHost')
  
  if (storedBaseUrl && storedBaseUrl.trim() !== '') {
    // 如果 dynamicBaseUrl 是完整 URL，直接返回
    if (storedBaseUrl.startsWith('http://') || storedBaseUrl.startsWith('https://')) {
      return storedBaseUrl.trim()
    }
    // 如果 dynamicBaseUrl 只是路径，需要拼接协议和 host
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https://' : 'http://'
    return `${protocol}${storedBaseUrl.trim()}`
  }
  
  // 使用 dynamicHost 构建完整 URL
  if (dynamicHost && dynamicHost.trim() !== '') {
    let hostname = dynamicHost.trim()
    // 如果 host 已经包含协议，需要提取纯 hostname
    if (hostname.startsWith('http://')) {
      hostname = hostname.replace('http://', '')
    } else if (hostname.startsWith('https://')) {
      hostname = hostname.replace('https://', '')
    }
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https://' : 'http://'
    return `${protocol}${hostname}/fzd-ceplatform-englishapp`
  }
  
  // 开发环境：如果没有从安卓获取的值，使用相对路径走代理
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_BASE_API || '/fzd-ceplatform-englishapp'
  }
  
  // 使用默认值
  const defaultHost = 'ceplatform2.fenzhidao.com'
  const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https://' : 'http://'
  const defaultBaseUrl = `${protocol}${defaultHost}/fzd-ceplatform-englishapp`
  
  return defaultBaseUrl
}

function getDynamicRagBaseUrl() {
  // 优先使用从安卓获取的 dynamicRagBaseUrl
  const storedRagBaseUrl = localStorage.getItem('dynamicRagBaseUrl')
  const dynamicHost = localStorage.getItem('dynamicHost')
  
  if (storedRagBaseUrl && storedRagBaseUrl.trim() !== '') {
    // 如果 dynamicRagBaseUrl 是完整 URL，直接返回
    if (storedRagBaseUrl.startsWith('http://') || storedRagBaseUrl.startsWith('https://')) {
      return storedRagBaseUrl.trim()
    }
    // 如果 dynamicRagBaseUrl 只是路径，需要拼接协议和 host
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https://' : 'http://'
    return `${protocol}${storedRagBaseUrl.trim()}`
  }
  
  // 使用 dynamicHost 构建完整 URL
  if (dynamicHost && dynamicHost.trim() !== '') {
    let hostname = dynamicHost.trim()
    // 如果 host 已经包含协议，需要提取纯 hostname
    if (hostname.startsWith('http://')) {
      hostname = hostname.replace('http://', '')
    } else if (hostname.startsWith('https://')) {
      hostname = hostname.replace('https://', '')
    }
    const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https://' : 'http://'
    return `${protocol}${hostname}/fzd-ceplatform-rag`
  }
  
  // 开发环境：如果没有从安卓获取的值，使用相对路径走代理
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_RAG_BASE_API || '/fzd-ceplatform-rag'
  }
  
  // 使用默认值
  const defaultHost = 'ceplatform2.fenzhidao.com'
  const protocol = typeof window !== 'undefined' && window.location.protocol === 'https:' ? 'https://' : 'http://'
  const defaultRagBaseUrl = `${protocol}${defaultHost}/fzd-ceplatform-rag`
  
  return defaultRagBaseUrl
}

// 基础 URL（每次调用时动态获取）
const getBaseUrl = () => getDynamicBaseUrl()
// RAG 基础 URL（每次调用时动态获取）
const getRagBaseUrl = () => getDynamicRagBaseUrl()

// 添加请求拦截器（例如：添加公共请求头）
const addRequestInterceptor = (options, customToken = null) => {
  const headers = {
    ...options.headers,
    'Cache-Control': 'no-cache',
    'Content-Type': 'application/json',
  }

  if (!options.skipAuth) {
    let token = customToken || (getToken().length > 0 ? getToken() : '')
    if (token && typeof token === 'string') {
      token = token.replace(/^Bearer[\s-]+/i, '').trim()
    }
    headers['X-Authorization-Token'] = token
  }

  options.headers = headers
  return options
}

// 添加响应拦截器（例如：统一处理错误）
const addResponseInterceptor = (response) => {
  // 在这里可以添加响应拦截逻辑，例如处理错误
  if (response.code !== 200) {
    return Promise.reject(new Error(response.message || '请求失败'))
  }
  return response
}

// 封装请求函数
export const enhancedRequest = async (options) => {
  // 添加请求拦截器（支持自定义 token）
  const customToken = options.token || null;
  const finalOptions = addRequestInterceptor({
    ...options,
    headers: {}
  }, customToken)

  const method = (options.method || 'GET').toUpperCase()
  
  // 构建 URL（动态获取 baseUrl）
  let fullUrl = getBaseUrl() + options.url

  // 调试用：打印最终请求路径
  if (process.env.NODE_ENV === 'development') {
    // 如果 fullUrl 已经是完整 URL（包含 http:// 或 https://），直接使用
    // 否则，在开发环境中会走代理
    const isFullUrl = fullUrl.startsWith('http://') || fullUrl.startsWith('https://')
    if (isFullUrl) {
      console.log('[HTTP]', method, fullUrl, '=>', fullUrl, '(直接请求，不走代理)')
    } else {
      const origin = window.location?.origin || ''
      console.log('[HTTP]', method, fullUrl, '=>', origin + fullUrl, '(走代理)')
    }
  }
  
  // GET 请求将参数拼接到 URL 上
  if (method === 'GET' && options.data) {
    const params = new URLSearchParams()
    Object.keys(options.data).forEach(key => {
      if (options.data[key] !== undefined && options.data[key] !== null) {
        params.append(key, String(options.data[key]))
      }
    })
    const queryString = params.toString()
    if (queryString) {
      fullUrl += (fullUrl.includes('?') ? '&' : '?') + queryString
    }
  }

  try {
    const fetchOptions = {
      method: method,
      headers: finalOptions.headers,
    }
    
    // 只有非 GET 请求才设置 body
    if (method !== 'GET' && options.data) {
      fetchOptions.body = JSON.stringify(options.data)
    }
    
    const response = await fetch(fullUrl, fetchOptions)

    const data = await response.json()

    const okByCode =
      data.code === 200 ||
      (Array.isArray(options.acceptBizCodes) &&
        options.acceptBizCodes.includes(data.code))

    // 根据具体情况处理响应
    if (okByCode) {
      if (data.code === 200) {
        return addResponseInterceptor(data)
      }
      return data
    } else {
      // token失效
      if (data.code == -50 || data.code == 405 || data.code == 406) {
        const params = JSON.stringify({
          "func": "otherLogin",
          "params": {
            "code": data.code,
            "msg": data.msg
          }
        })
        if (window.android) {
          window.android.callNative(params)
        }
      } else {
        // 记录错误，不显示浏览器弹窗（避免影响用户体验）
        console.error('请求失败:', data.msg || '请求失败', '状态码:', data.code)
      }
      // throw new Error(`请求失败，状态码: ${data.code}`)
    }
  } catch (error) {
    // 检测跨域错误
    if (error instanceof TypeError && (
      error.message.includes('Failed to fetch') ||
      error.message.includes('NetworkError') ||
      error.message.includes('Network request failed') ||
      error.message.includes('Load failed')
    )) {
      console.error('❌ 跨域错误 (CORS Error):', {
        url: fullUrl,
        method: method,
        error: error.message,
        message: '请求被浏览器阻止，可能是跨域问题。请检查服务器 CORS 配置。'
      })
    } else {
      console.error('请求错误:', error)
    }
    throw error
  }
}

// 流式请求
export const streamRequest = (options, onMessage, onComplete) => {
  return new Promise((resolve, reject) => {
    console.log('options', options)
    const fullUrl = getBaseUrl() + options.url

    const xhr = new XMLHttpRequest()
    let buffer = '' // 用于存储累积的数据

    const token = getToken().length > 0 ? getToken() : ''

    const method = 'POST'

    // 调试用：打印最终请求路径
    if (process.env.NODE_ENV === 'development') {
      const isFullUrl = fullUrl.startsWith('http://') || fullUrl.startsWith('https://')
      if (isFullUrl) {
        console.log('[HTTP-STREAM]', method, fullUrl, '=>', fullUrl, '(直接请求，不走代理)')
      } else {
        const origin = window.location?.origin || ''
        console.log('[HTTP-STREAM]', method, fullUrl, '=>', origin + fullUrl, '(走代理)')
      }
    }

    xhr.open(method, fullUrl, true)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.setRequestHeader('Cache-Control', 'no-cache')
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest')
    xhr.setRequestHeader('X-Authorization-Token', token)
    xhr.responseType = ''

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 3 || xhr.readyState === 4) {
        try {
          // 检查响应状态
          if (xhr.status === 200) {
            const newData = xhr.responseText.substring(buffer.length)
            buffer = xhr.responseText

            if (newData) {
              const lines = newData.split('\n').filter(line => line.trim())
              for (const line of lines) {
                const cleanedLine = line.replace(/^data:\s*/, '').trim()
                if (cleanedLine) {
                  try {
                    const data = JSON.parse(cleanedLine)
                    if (data.code == 500) {
                      // 记录错误，不显示浏览器弹窗（避免影响用户体验）
                      console.error('服务器错误:', data.msg || '服务器错误')
                      reject(new Error(data.msg || '服务器错误'))
                      return
                    }
                    // 检查 token 失效的情况
                    if (data.code === -50 || data.code === 405 || data.code === 406) {
                      const params = JSON.stringify({
                        "func": "otherLogin",
                        "params": {
                          "code": data.code,
                          "msg": data.msg
                        }
                      })
                      console.log('token过期', params)
                      if (window.android) {
                        window.android.callNative(params)
                      }
                      xhr.abort() // 中断请求
                      reject(new Error('token失效'))
                      return
                    }

                    if (data.content) {
                      onMessage(data.content)
                    }
                  } catch (e) {
                    if (cleanedLine !== '[DONE]') {
                      onMessage(cleanedLine)
                    }
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('处理数据时出错:', error)
        }
      }
    }

    xhr.onload = () => {
      if (xhr.status === 200) {
        // 重要：在请求完成时，再次处理 responseText 中剩余的数据
        // 因为 onreadystatechange 可能没有处理完所有数据
        try {
          const remainingData = xhr.responseText.substring(buffer.length)
          if (remainingData) {
            const lines = remainingData.split('\n').filter(line => line.trim())
            for (const line of lines) {
              const cleanedLine = line.replace(/^data:\s*/, '').trim()
              if (cleanedLine) {
                try {
                  const data = JSON.parse(cleanedLine)
                  
                  if (data.code == 500) {
                    console.error('服务器错误:', data.msg || '服务器错误')
                    reject(new Error(data.msg || '服务器错误'))
                    return
                  }
                  
                  if (data.code === -50 || data.code === 405 || data.code === 406) {
                    const params = JSON.stringify({
                      "func": "otherLogin",
                      "params": {
                        "code": data.code,
                        "msg": data.msg
                      }
                    })
                    console.log('token过期', params)
                    if (window.android) {
                      window.android.callNative(params)
                    }
                    xhr.abort()
                    reject(new Error('token失效'))
                    return
                  }
                  
                  if (data.content) {
                    onMessage(data.content)
                  }
                } catch (e) {
                  if (cleanedLine !== '[DONE]') {
                    onMessage(cleanedLine)
                  }
                }
              }
            }
            // 更新 buffer，避免重复处理
            buffer = xhr.responseText
          }
        } catch (error) {
          console.error('处理剩余数据时出错:', error)
        }
        
        // 使用 setTimeout 确保所有同步的回调函数都已执行完
        // 这样可以确保流式数据完全处理完成后再 resolve
        setTimeout(() => {
          // 调用onComplete回调通知请求完成
          if (onComplete && typeof onComplete === 'function') {
            onComplete()
          }
          resolve(xhr.response)
        }, 0)
      } else {
        // 处理非 200 状态码的响应
        try {
          const response = JSON.parse(xhr.response)
          if (response.code === -50 || response.code === 405 || response.code === 406) {
            const params = JSON.stringify({
              "func": "otherLogin",
              "params": {
                "code": response.code,
                "msg": response.msg
              }
            })
            console.log('token过期', params)
            if (window.android) {
              window.android.callNative(params)
            }
          }
        } catch (e) {
          console.error('解析响应失败:', e)
        }
        reject(new Error(`请求失败，状态码: ${xhr.status}`))
      }
    }

    xhr.onerror = (error) => {
      // 检测跨域错误（XMLHttpRequest 跨域时 status 为 0）
      if (xhr.status === 0) {
        console.error('❌ 跨域错误 (CORS Error):', {
          url: fullUrl,
          method: 'POST',
          status: xhr.status,
          statusText: xhr.statusText,
          message: '请求被浏览器阻止，可能是跨域问题。请检查服务器 CORS 配置。'
        })
      } else {
        console.error('请求错误:', error, '状态码:', xhr.status)
      }
      reject(error)
    }

    try {
      xhr.send(JSON.stringify(options.data))
    } catch (error) {
      reject(error)
    }

    return {
      abort: () => xhr.abort()
    }
  })
}

// RAG 流式请求（传递完整数据对象，不解析 content 字段）
export const ragStreamRequestFull = (options, onMessage, onComplete) => {
  let xhr = null; // 将 xhr 提升到外部作用域，以便 abort 方法可以访问
  
  const promise = new Promise((resolve, reject) => {
    const customToken = options.token || null
    const finalOptions = addRequestInterceptor({
      ...options,
      headers: {}
    }, customToken)

    const fullUrl = getRagBaseUrl() + options.url
    xhr = new XMLHttpRequest() // 使用外部作用域的 xhr
    let buffer = '' // 用于存储累积的数据

    const method = (options.method || 'POST').toUpperCase()

    // 调试用：打印最终请求路径
    if (process.env.NODE_ENV === 'development') {
      const isFullUrl = fullUrl.startsWith('http://') || fullUrl.startsWith('https://')
      if (isFullUrl) {
        console.log('[HTTP-RAG-STREAM-FULL]', method, fullUrl, '=>', fullUrl, '(直接请求，不走代理)')
      } else {
        const origin = window.location?.origin || ''
        console.log('[HTTP-RAG-STREAM-FULL]', method, fullUrl, '=>', origin + fullUrl, '(走代理)')
      }
    }

    const requestStartTime = performance.now(); // 记录请求开始时间
    
    xhr.open(method, fullUrl, true)

    // 复用请求拦截器计算出的 headers（包含 Content-Type、Cache-Control、X-Authorization-Token 等）
    if (finalOptions.headers && typeof finalOptions.headers === 'object') {
      Object.keys(finalOptions.headers).forEach((k) => {
        try {
          xhr.setRequestHeader(k, finalOptions.headers[k])
        } catch (e) {
          // 忽略非法 header
        }
      })
    }

    xhr.responseType = ''
    // 设置请求超时（5分钟，流式请求可能需要较长时间）
    // 注意：对于 TTS 流式请求，可能需要更长时间，所以设置为 5 分钟
    xhr.timeout = 300000 // 5分钟 = 300000ms
    xhr.ontimeout = () => {
      const timeoutDuration = performance.now() - requestStartTime;
      console.error(`❌ RAG 流式请求超时（耗时: ${timeoutDuration.toFixed(2)}ms）:`, fullUrl)
      reject(new Error('请求超时'))
    }
    
    // 记录请求发送时间
    xhr.onloadstart = () => {
      const loadStartTime = performance.now() - requestStartTime;
      if (process.env.NODE_ENV === 'development') {
        console.log(`🚀 [RAG-STREAM] 请求开始发送，耗时: ${loadStartTime.toFixed(2)}ms`, fullUrl);
      }
    }

    let firstChunkTime = null; // 记录首次收到数据的时间
    
    xhr.onreadystatechange = () => {
      // 优化：优先处理 readyState === 3（正在接收数据），确保实时性
      if (xhr.readyState === 3 || xhr.readyState === 4) {
        try {
          if (xhr.status === 200) {
            const newData = xhr.responseText.substring(buffer.length)
            buffer = xhr.responseText

            if (newData) {
              // 记录首次数据到达时间
              if (firstChunkTime === null) {
                firstChunkTime = performance.now();
                const timeToFirstChunk = firstChunkTime - requestStartTime;
                if (process.env.NODE_ENV === 'development') {
                  console.log(`⚡ [RAG-STREAM] 首次数据到达，耗时: ${timeToFirstChunk.toFixed(2)}ms`, fullUrl);
                }
              }
              
              // 优化：直接处理数据，不使用 queueMicrotask（避免延迟）
              // 但确保数据处理不会阻塞后续数据接收
              const lines = newData.split('\n').filter(line => line.trim())
              for (const line of lines) {
                const cleanedLine = line.replace(/^data:\s*/, '').trim()
                if (cleanedLine) {
                  try {
                    const data = JSON.parse(cleanedLine)

                    if (data.code == 500) {
                      console.error('服务器错误:', data.msg || '服务器错误')
                      reject(new Error(data.msg || '服务器错误'))
                      return
                    }

                    if (data.code === -50 || data.code === 405 || data.code === 406) {
                      const params = JSON.stringify({
                        "func": "otherLogin",
                        "params": {
                          "code": data.code,
                          "msg": data.msg
                        }
                      })
                      console.log('token过期', params)
                      if (window.android) {
                        window.android.callNative(params)
                      }
                      xhr.abort()
                      reject(new Error('token失效'))
                      return
                    }

                    // 直接调用回调函数，确保实时性
                    onMessage(data)
                  } catch (e) {
                    if (cleanedLine !== '[DONE]') {
                      // 如果不是 JSON，直接传递原始字符串
                      onMessage(cleanedLine)
                    }
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('处理数据时出错:', error)
        }
      }
    }

    xhr.onload = () => {
      const totalTime = performance.now() - requestStartTime;
      if (xhr.status === 200) {
        if (process.env.NODE_ENV === 'development') {
          console.log(`✅ [RAG-STREAM-FULL] 请求完成，总耗时: ${totalTime.toFixed(2)}ms`, fullUrl);
        }
        
        // 使用 setTimeout 确保所有同步的回调函数都已执行完
        // 这样可以确保流式数据完全处理完成后再 resolve
        setTimeout(() => {
          // 调用onComplete回调通知请求完成
          if (onComplete && typeof onComplete === 'function') {
            onComplete()
          }
          resolve(xhr.response)
        }, 0)
      } else {
        try {
          const response = JSON.parse(xhr.response)
          if (response.code === -50 || response.code === 405 || response.code === 406) {
            const params = JSON.stringify({
              "func": "otherLogin",
              "params": {
                "code": response.code,
                "msg": response.msg
              }
            })
            console.log('token过期', params)
            if (window.android) {
              window.android.callNative(params)
            }
          }
        } catch (e) {
          console.error('解析响应失败:', e)
        }
        reject(new Error(`请求失败，状态码: ${xhr.status}`))
      }
    }

    xhr.onerror = (error) => {
      const totalTime = performance.now() - requestStartTime;
      if (xhr.status === 0) {
        console.error(`❌ RAG 跨域错误 (CORS Error)（耗时: ${totalTime.toFixed(2)}ms）:`, {
          url: fullUrl,
          method: method,
          status: xhr.status,
          statusText: xhr.statusText,
          message: '请求被浏览器阻止，可能是跨域问题。请检查服务器 CORS 配置。'
        })
      } else {
        console.error(`RAG 请求错误（耗时: ${totalTime.toFixed(2)}ms）:`, error, '状态码:', xhr.status)
      }
      reject(error)
    }

    try {
      xhr.send(JSON.stringify(options.data || {}))
    } catch (error) {
      reject(error)
    }
  })
  
  // 返回包含 Promise 和 abort 方法的对象
  return {
    then: promise.then.bind(promise),
    catch: promise.catch.bind(promise),
    finally: promise.finally?.bind(promise),
    abort: () => {
      if (xhr) {
        xhr.abort();
        console.log('✅ 已取消 RAG 流式请求:', options.url);
      }
    }
  };
}

// RAG 流式请求（使用不同的 baseUrl，并支持自定义 token）
export const ragStreamRequest = (options, onMessage, onComplete) => {
  let xhr = null
  const promise = new Promise((resolve, reject) => {
    const customToken = options.token || null
    const finalOptions = addRequestInterceptor({
      ...options,
      headers: {}
    }, customToken)

    const ragBase = getRagBaseUrl()
    const fullUrl = ragBase + options.url
    xhr = new XMLHttpRequest()
    let buffer = '' // 用于存储累积的数据

    const method = (options.method || 'POST').toUpperCase()

    // 老师评价（报告解析）：代理前完整路径 = 浏览器实际请求的 URL（相对路径时会拼上当前页 origin，便于本地走 devServer 代理）
    if (String(options.url || '').includes('parsePrompt')) {
      const tokenHeader = finalOptions.headers['X-Authorization-Token']
      const isRelative =
        typeof fullUrl === 'string' &&
        fullUrl.length > 0 &&
        !/^https?:\/\//i.test(fullUrl)
      const 代理前完整路径 =
        typeof window !== 'undefined' && isRelative
          ? `${window.location.origin}${fullUrl.startsWith('/') ? '' : '/'}${fullUrl}`
          : fullUrl
      console.log('[老师评价 parsePrompt] 代理前完整路径:', 代理前完整路径)
      console.log('[老师评价 parsePrompt][代理前]', {
        代理前完整路径,
        method,
        ragBase,
        path: options.url,
        xhrOpenUrl: fullUrl,
        body: options.data || {},
        hasToken: Boolean(
          tokenHeader && String(tokenHeader).replace(/\s/g, '').length > 0
        ),
      })
    }

    // 调试用：打印最终请求路径
    if (process.env.NODE_ENV === 'development') {
      const isFullUrl = fullUrl.startsWith('http://') || fullUrl.startsWith('https://')
      if (isFullUrl) {
        console.log('[HTTP-RAG-STREAM]', method, fullUrl, '=>', fullUrl, '(直接请求，不走代理)')
      } else {
        const origin = window.location?.origin || ''
        console.log('[HTTP-RAG-STREAM]', method, fullUrl, '=>', origin + fullUrl, '(走代理)')
      }
    }

    xhr.open(method, fullUrl, true)

    // 复用请求拦截器计算出的 headers（包含 Content-Type、Cache-Control、X-Authorization-Token 等）
    if (finalOptions.headers && typeof finalOptions.headers === 'object') {
      Object.keys(finalOptions.headers).forEach((k) => {
        try {
          xhr.setRequestHeader(k, finalOptions.headers[k])
        } catch (e) {
          // 忽略非法 header
        }
      })
    }

    xhr.responseType = ''

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 3 || xhr.readyState === 4) {
        try {
          if (xhr.status === 200) {
            const newData = xhr.responseText.substring(buffer.length)
            buffer = xhr.responseText

            if (newData) {
              const lines = newData.split('\n').filter(line => line.trim())
              for (const line of lines) {
                const cleanedLine = line.replace(/^data:\s*/, '').trim()
                if (cleanedLine) {
                  try {
                    const data = JSON.parse(cleanedLine)

                    if (data.code == 500) {
                      console.error('服务器错误:', data.msg || '服务器错误')
                      reject(new Error(data.msg || '服务器错误'))
                      return
                    }

                    if (data.code === -50 || data.code === 405 || data.code === 406) {
                      const params = JSON.stringify({
                        "func": "otherLogin",
                        "params": {
                          "code": data.code,
                          "msg": data.msg
                        }
                      })
                      console.log('token过期', params)
                      if (window.android) {
                        window.android.callNative(params)
                      }
                      xhr.abort()
                      reject(new Error('token失效'))
                      return
                    }

                    if (data.content) {
                      onMessage(data.content)
                    }
                  } catch (e) {
                    if (cleanedLine !== '[DONE]') {
                      onMessage(cleanedLine)
                    }
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('处理数据时出错:', error)
        }
      }
    }

    xhr.onload = () => {
      if (xhr.status === 200) {
        // 重要：在请求完成时，再次处理 responseText 中剩余的数据
        // 因为 onreadystatechange 可能没有处理完所有数据
        try {
          const remainingData = xhr.responseText.substring(buffer.length)
          if (remainingData) {
            const lines = remainingData.split('\n').filter(line => line.trim())
            for (const line of lines) {
              const cleanedLine = line.replace(/^data:\s*/, '').trim()
              if (cleanedLine) {
                try {
                  const data = JSON.parse(cleanedLine)
                  
                  if (data.code == 500) {
                    console.error('服务器错误:', data.msg || '服务器错误')
                    reject(new Error(data.msg || '服务器错误'))
                    return
                  }
                  
                  if (data.code === -50 || data.code === 405 || data.code === 406) {
                    const params = JSON.stringify({
                      "func": "otherLogin",
                      "params": {
                        "code": data.code,
                        "msg": data.msg
                      }
                    })
                    console.log('token过期', params)
                    if (window.android) {
                      window.android.callNative(params)
                    }
                    xhr.abort()
                    reject(new Error('token失效'))
                    return
                  }
                  
                  if (data.content) {
                    onMessage(data.content)
                  }
                } catch (e) {
                  if (cleanedLine !== '[DONE]') {
                    onMessage(cleanedLine)
                  }
                }
              }
            }
            // 更新 buffer，避免重复处理
            buffer = xhr.responseText
          }
        } catch (error) {
          console.error('处理剩余数据时出错:', error)
        }
        
        // 使用 setTimeout 确保所有同步的回调函数都已执行完
        // 这样可以确保流式数据完全处理完成后再 resolve
        setTimeout(() => {
          // 调用onComplete回调通知请求完成
          if (onComplete && typeof onComplete === 'function') {
            onComplete()
          }
          resolve(xhr.response)
        }, 0)
      } else {
        try {
          const response = JSON.parse(xhr.response)
          if (response.code === -50 || response.code === 405 || response.code === 406) {
            const params = JSON.stringify({
              "func": "otherLogin",
              "params": {
                "code": response.code,
                "msg": response.msg
              }
            })
            console.log('token过期', params)
            if (window.android) {
              window.android.callNative(params)
            }
          }
        } catch (e) {
          console.error('解析响应失败:', e)
        }
        reject(new Error(`请求失败，状态码: ${xhr.status}`))
      }
    }

    xhr.onerror = (error) => {
      if (xhr.status === 0) {
        console.error('❌ RAG 跨域错误 (CORS Error):', {
          url: fullUrl,
          method: method,
          status: xhr.status,
          statusText: xhr.statusText,
          message: '请求被浏览器阻止，可能是跨域问题。请检查服务器 CORS 配置。'
        })
      } else {
        console.error('RAG 请求错误:', error, '状态码:', xhr.status)
      }
      reject(error)
    }

    try {
      xhr.send(JSON.stringify(options.data || {}))
    } catch (error) {
      reject(error)
    }

  })
  return {
    then: promise.then.bind(promise),
    catch: promise.catch.bind(promise),
    finally: promise.finally?.bind(promise),
    abort: () => {
      if (xhr) {
        xhr.abort()
        if (process.env.NODE_ENV === 'development') {
          console.log('[HTTP-RAG-STREAM][ABORT]', options.url)
        }
      }
    }
  }
}

// RAG 接口专用请求函数（使用不同的 baseUrl）
export const ragRequest = async (options) => {
  // 添加请求拦截器，支持传入自定义 token（options.token）
  const customToken = options.token || null
  const finalOptions = addRequestInterceptor({
    ...options,
    headers: {}
  }, customToken)

  const method = (options.method || 'GET').toUpperCase()
  
  // 构建 URL（使用 RAG baseUrl，动态获取）
  let fullUrl = getRagBaseUrl() + options.url

  // 调试用：打印最终请求路径（走代理时显示真实后端地址，与 vue.config.js proxy target 一致）
  if (process.env.NODE_ENV === 'development') {
    const isFullUrl = fullUrl.startsWith('http://') || fullUrl.startsWith('https://')
    const RAG_PROXY_TARGET = 'https://ceplatform.fenzhidao.com' // 与 vue.config.js 中 /fzd-ceplatform-rag 的 target 保持一致
    if (isFullUrl) {
      console.log('[HTTP-RAG]', method, fullUrl, '=>', fullUrl, '(直接请求，不走代理)')
    } else {
      const origin = window.location?.origin || ''
      const realBackendUrl = RAG_PROXY_TARGET + fullUrl
      console.log('[HTTP-RAG]', method, fullUrl)
      console.log('   -> 浏览器请求:', origin + fullUrl)
      console.log('   -> 代理转发到:', realBackendUrl, '(正式服)')
    }
  }
  
  // GET 请求将参数拼接到 URL 上
  if (method === 'GET' && options.data) {
    const params = new URLSearchParams()
    Object.keys(options.data).forEach(key => {
      if (options.data[key] !== undefined && options.data[key] !== null) {
        params.append(key, String(options.data[key]))
      }
    })
    const queryString = params.toString()
    if (queryString) {
      fullUrl += (fullUrl.includes('?') ? '&' : '?') + queryString
    }
  }

  try {
    const fetchOptions = {
      method: method,
      headers: finalOptions.headers,
    }
    if (options.signal) {
      fetchOptions.signal = options.signal
    }
    
    // 只有非 GET 请求才设置 body
    if (method !== 'GET' && options.data) {
      fetchOptions.body = JSON.stringify(options.data)
    }
    
    const response = await fetch(fullUrl, fetchOptions)
    
    // 先检查 HTTP 状态码
    if (!response.ok) {
      console.error('❌ RAG 请求 HTTP 错误:', {
        status: response.status,
        statusText: response.statusText,
        url: fullUrl,
      })
      // 尝试解析错误响应
      try {
        const errorData = await response.json()
        console.error('错误响应数据:', errorData)
        throw new Error(`HTTP ${response.status}: ${errorData.msg || response.statusText}`)
      } catch (e) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }
    }

    const data = await response.json()

    // 根据具体情况处理响应
    if (data.code === 200 || data.code === 0) {
      return addResponseInterceptor(data)
    } else {
      // token失效
      if (data.code == -50 || data.code == 405 || data.code == 406) {
        const params = JSON.stringify({
          "func": "otherLogin",
          "params": {
            "code": data.code,
            "msg": data.msg
          }
        })
        console.log('token过期', params)
        if (window.android) {
          window.android.callNative(params)
        }
      } else {
        // 记录错误，不显示浏览器弹窗（避免影响用户体验）
        console.error('RAG 请求失败:', data.msg || '请求失败', '状态码:', data.code)
      }
      throw new Error(`请求失败，状态码: ${data.code}`)
    }
  } catch (error) {
    // 检测跨域错误
    if (error instanceof TypeError && (
      error.message.includes('Failed to fetch') ||
      error.message.includes('NetworkError') ||
      error.message.includes('Network request failed') ||
      error.message.includes('Load failed')
    )) {
      console.error('❌ RAG 跨域错误 (CORS Error):', {
        url: fullUrl,
        method: method,
        error: error.message,
        message: '请求被浏览器阻止，可能是跨域问题。请检查服务器 CORS 配置。'
      })
    } else {
      console.error('RAG 请求错误:', error)
    }
    throw error
  }
}

